import { Directive, HostBinding, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'button, [bkuiForwardOnHover]',
  host: {
    '[style.transition]': '"var(--forward-shadow-transition)"',
  }
})
export class ForwardOnHoverDirective {
  @Input() forward = true;
  @Input() inward = true;
  @Input() shadow:
    | 'light-shadow'
    | 'medium-shadow'
    | 'dark-shadow' = 'light-shadow';

  @HostBinding('class') private get _pullForwards() {
    return this.forward && this._mouseover && !this._mousedown && `pull-forward ${this.shadow}` || ''
  }

  @HostBinding('class.pull-inward') private get _pullInwards() {
    return this.inward && this._mousedown;
  }

  private _mouseover = false;
  private _mousedown = false;

  @HostListener('mouseover')
  onMouseOver() {
    this._mouseover = true;
  }

  @HostListener('mouseout')
  onMouseOut() {
    this._mouseover = false;
    this._mousedown = false;
  }

  @HostListener('mousedown')
  onMouseDown() {
    this._mousedown = true;
  }

  @HostListener('mouseup')
  onMouseUp() {
    this._mousedown = false;
  }
}
